import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const MaskedLines = ({
  lines,
  as: Tag = "h1",
  className = "",
  delay = 0,
  stagger = 0.13,
  testid,
}) => (
  <Tag className={className} data-testid={testid}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className="block will-change-transform"
          initial={{ y: "112%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.95, delay: delay + i * stagger, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const FadeUp = ({ children, delay = 0, y = 28, className = "", testid }) => (
  <motion.div
    className={className}
    data-testid={testid}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const StaggerGroup = ({ children, className = "", testid }) => (
  <motion.div
    className={className}
    data-testid={testid}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.12 }}
    variants={{
      hidden: {},
      show: { transition: { staggerChildren: 0.09 } },
    }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", testid }) => (
  <motion.div
    className={className}
    data-testid={testid}
    variants={{
      hidden: { opacity: 0, y: 26 },
      show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
    }}
  >
    {children}
  </motion.div>
);
